import React from 'react';
import PropTypes from 'prop-types';
import { Link as FabricLink } from 'office-ui-fabric-react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';

/**
 * Combines fluent/fabric link with react router.
 */
const Link = ({ children, href, to, className: classNameProp, ...other }) => {
  const className = clsx(classNameProp);

  return (
    <FabricLink className={className} to={href || to} as={RouterLink} {...other}>
      {children}
    </FabricLink>
  );
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  className: PropTypes.string,
};

Link.defaultProps = {
  className: '',
  href: '',
  to: '',
};

export default Link;
